import axios from 'axios';

const client = axios.create();
client.defaults.baseURL = process.env.API_INSTAGRAM;

// Interceptors makes mocking our tests very difficult, lets
// ignore them within tests.
if (process.env.NODE_ENV !== 'test') {
  client.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token');
      const requestConfig = config;
      if (token) {
        requestConfig.headers.Authorization = `JWT ${token}`;
      }
      return requestConfig;
    },
    error => Promise.reject(error),
  );
  client.interceptors.response.use(
    response => response,
    error => {
      // Handle when a token has expired
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        window.location.assign('/login');
      }
      return Promise.reject(error);
    },
  );
}

export default client;



// WEBPACK FOOTER //
// ./src/api/instagram.js